import cs from 'classnames';
import dynamic from 'next/dynamic';
import type { FC, ReactNode } from 'react';
import { useMemo } from 'react';
import { Box } from '@/DesignSystem/Component';
import { prepareCommentFullName } from '@/Module/Comment/Helper';
import type { IComment } from '@/Module/Comment/Model/DataModel';
import { dayjs } from '@/Module/Core/Helper';
import { IconReply } from '@/Module/Icon';
import { useAppSelector } from '@/Module/Store/Hook';
const CommentForm = dynamic(() => import('@/Module/Comment/Component/CommentRegister/CommentRegister'));
interface ICommentProps {
  commentId: IComment['id'];
  fullName: ReactNode;
  description: string;
  replyId?: IComment['id'];
  createdDate?: string;
  isReply?: boolean;
  comments?: IComment[];
}
const CommentView: FC<ICommentProps> = ({
  fullName,
  createdDate,
  description,
  isReply,
  commentId,
  replyId,
  comments
}) => {
  const selectedId = useAppSelector(state => state.comment.replyId);
  const isReplying = selectedId === (replyId ?? commentId);
  const formattedDate = useMemo(() => {
    if (!createdDate) return '';
    return dayjs(createdDate).calendar('jalali').format('DD MMMM YYYY | HH:mm');
  }, [createdDate]);
  const Container = isReply ? 'div' : Box;
  return <Container color="primaryMiddle" className={cs('mb-6 last:mb-0', !isReply && 'border-4 border-blueThree  p-4  sm:py-12 sm:px-16 mb-12')} data-sentry-element="Container" data-sentry-component="CommentView" data-sentry-source-file="CommentView.tsx">
      <div className="mb-4 flex items-center justify-between border-b border-b-blueFour py-4 text-xl">
        <div className="flex items-center gap-2 text-sm text-blueFour sm:text-base ">
          {isReply && <IconReply size="small" />}
          <span dir="ltr">{fullName}</span>
        </div>
        <span className="text-sm text-blueThree  sm:text-base">{formattedDate}</span>
      </div>
      <div>
        <div className="prose max-w-full overflow-x-clip text-gray-500">
          <p>{description}</p>
        </div>
      </div>

      {isReplying && <div className="mt-6">
          <CommentForm parentId={replyId ?? commentId} />
        </div>}

      {!!comments?.length && <div className="mt-6 border-t border-t-blueFour pr-10">
          {comments.map(item => <CommentView key={item.id} commentId={item.id} fullName={prepareCommentFullName(item)} description={item.commentText} replyId={commentId} createdDate={item.createdDate} isReply />)}
        </div>}
    </Container>;
};
export default CommentView;